"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function fromQueryString(queryString) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '?';

  if (!queryString) {
    return {};
  }

  return queryString.replace(prefix, '').split('&').reduce(function (accumulator, currentPair) {
    var data = currentPair.split('=');

    if (data.length === 2) {
      accumulator[decodeURIComponent(data[0])] = decodeURIComponent(data[1]);
    }

    return accumulator;
  }, {});
}

var _default = fromQueryString;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@creuna/utils/from-query-string.js
// module id = 213
// module chunks = 0